import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
// slices
import mailReducer from './slices/mail';
import chatReducer from './slices/chat';
import productReducer from './slices/product';
import calendarReducer from './slices/calendar';
import kanbanReducer from './slices/kanban';
import commonReducer from './slices/common';
import userReducer from './slices/user';
import tutorialReducer from './slices/tutorial';
import testStateReducer from './slices/Rav-testState';
import adminPagesReducer from './slices/adminPages';

// ----------------------------------------------------------------------

const rootPersistConfig = {
  key: 'root',
  storage,
  keyPrefix: 'redux-',
  whitelist: [],
};

const productPersistConfig = {
  key: 'product',
  storage,
  keyPrefix: 'redux-',
  whitelist: ['sortBy', 'checkout'],
};

const userPersistConfig = {
  key: 'user',
  storage,
  keyPrefix: 'redux-',
};

const tutorialPersistConfig = {
  key: 'tutorial',
  storage,
  keyPrefix: 'redux-',
};

const testStatePersistConfig = {
  key: 'testState',
  storage,
  keyPrefix: 'redux-',
};

const adminPagesPersistConfig = {
  key: 'adminPages',
  storage,
  keyPrefix: 'redux-',
};


const rootReducer = combineReducers({
  mail: mailReducer,
  chat: chatReducer,
  calendar: calendarReducer,
  kanban: kanbanReducer,
  common: commonReducer,
  product: persistReducer(productPersistConfig, productReducer),
  user: persistReducer(userPersistConfig, userReducer),
  tutorial: persistReducer(tutorialPersistConfig, tutorialReducer),
  testState: persistReducer(testStatePersistConfig, testStateReducer),
  adminPages: persistReducer(adminPagesPersistConfig, adminPagesReducer),
});

export { rootPersistConfig, rootReducer };
